import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Metadata from '../Metadata'
import { renderOptions } from './renderOptions'
import style from '../../styles/components/static-pages'

const StaticPageDetails = ({ data: { title, description, thumbnail, content } }) => (
  <>
    <Metadata metadata={{ title: `Cheddar News - ${title}`, thumbnail, description }} />
    <div className='container'>
      <div className='static-page-wrapper'>
        <div className='title'>{title}</div>
        {documentToReactComponents(content, renderOptions)}
      </div>
    </div>
    <style jsx>{style}</style>
  </>
)

export default StaticPageDetails
